import * as types from "./actionTypes";

export const timesheetsSetIsLoading = (isLoading) => ({
  type: types.TIMESHEETS_SET_IS_LOADING,
  payload: isLoading,
});

export const timesheetsSetData = (timesheets) => ({
  type: types.TIMESHEETS_SET_DATA,
  payload: timesheets,
});

export const setNonAttendanceLookupData = (nonAttendanceLookups) => ({
  type: types.NON_ATTENDANCE_LOOKUP_DATA,
  payload: nonAttendanceLookups,
});

export const timesheetsRequestData = () => ({
  type: types.TIMESHEETS_REQUEST_DATA,
});

export const timesheetRequestUpdate = (timesheet, shouldSendNotification) => ({
  type: types.TIMESHEET_IS_UPDATING,
  payload: { timesheet, shouldSendNotification },
});

export const timesheetUpdateSuccess = (timesheet) => ({
  type: types.TIMESHEET_UPDATE_SUCCESS,
  payload: timesheet,
});

export const timesheetUpdateFailed = (timesheet) => ({
  type: types.TIMESHEET_UPDATE_FAILED,
  payload: timesheet,
});

export const timesheetSendFeedback = (timesheetNumber, score, comments) => ({
  type: types.TIMESHEET_SEND_FEEDBACK,
  payload: { timesheetNumber, score, comments },
});
